export default __webpack_public_path__ + "static/logo-h-7d883ed448b4a1b521fc4425cca9fb1d.svg";